import {Component, Inject, Vue} from 'vue-property-decorator';
import JunkItHeader from '@/components/header/junk-it-header.vue'
import EditProfile from '@/components/edit-profile/edit-profile.vue'

@Component({
  components: {
    JunkItHeader,
    EditProfile,
  },
})
export default class Home extends Vue {
}
